export const Shadow = {
  SMALL: '0px 0px 20px rgba(0, 0, 0, 0.02), 2px 4px 8px rgba(0, 0, 0, 0.08)',
  MEDIUM: '0px 4px 12px rgba(0, 0, 0, 0.16), 4px 8px 28px rgba(0, 0, 0, 0.08)',
};
